<template>
  <b-container fluid class="home">
    <b-row>
      <b-col md="5" sm="12" order-md="1" order="2">
        <Navbar class="d-none d-md-flex"></Navbar>
        <div class="mt-4">
          <p>
            Cartographe indépendant, je vous accompagne dans la réalisation d'une représentation
            graphique de vos données géographiques.
          </p>
          <p>
            Mes compétences s’accordent avec vos besoins : cartographie d'édition ou journalistique,
            plans touristiques et brochures urbaines, représentations géographiques pour le
            domaine de l'éducation et de la recherche, de l'urbanisme ou mise en forme graphique
            de vos données et sur tous types de supports.
          </p>
          <div class="partners-container d-flex mt-5">
            <p class="my-auto font-weight-bold">Ils me font confiance : </p>
            <img v-for="partner in partners" :key="partner.name" :src="partner.src">
          </div>
        </div>
      </b-col>
      <b-col md="7" sm="12" order-md="2" order="1" class="carousel-container">
        <b-carousel
          id="carousel-1"
          :interval="4000"
          controls
          indicators
          style="text-shadow: 1px 1px 2px #333;">
          <b-carousel-slide v-for="carte in cartes" :key="carte.name"
          :img-src="carte.src">
          </b-carousel-slide>
        </b-carousel>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Constants from '@/constants';

export default {
  components: {
    Navbar,
  },
  data() {
    return {
      cartes: Constants.homeCartes,
      partners: Constants.partners,
    };
  },
};
</script>

<style lang="scss" scoped>
  .carousel-container {
    align-self: center;
  }
  p {
    font-family: "Robotoo";
    font-weight: $font-weight-light;
  }
  .partners-container {
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 21px;
    img {
      max-width: 105px;
    }
  }
</style>
